import { render, staticRenderFns } from "./SettlementsAddPopup.vue?vue&type=template&id=0637e8c4&"
import script from "./SettlementsAddPopup.vue?vue&type=script&lang=js&"
export * from "./SettlementsAddPopup.vue?vue&type=script&lang=js&"
import style0 from "./SettlementsAddPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports